<template>
  <div class="tab tall flex-1 no-min-width flex items-center">
    <i :class="iconClassName"></i>
    <span class="capitalize select-none break-words">{{ tabText }}</span>
  </div>
</template>

<script>
import BdgTab from "./BdgTab";

export default {
  name: "BdgGroupTab",
  extends: BdgTab
};
</script>

<style lang="scss" scoped></style>
